import { useEffect, useState } from "react";
import api from "../constant/api";
import { motion, AnimatePresence } from "framer-motion";
import {
  PDFDownloadLink,
  pdf,
} from "@react-pdf/renderer";
import { toast } from "react-toastify";
import PurchasePDF from "./PurchasePDF";
import moment from "moment/moment";

export default function PurchaseOrder() {
const [
  selectedBranch,
  setSelectedBranch
] = useState(
  localStorage.getItem(
    "selectedBranch"
  ) || "2"
);

useEffect(() => {

  const updateBranch = () => {

    const branch =
      localStorage.getItem(
        "selectedBranch"
      );

    setSelectedBranch(branch);

    console.log(
      "Updated Branch:",
      branch
    );

  };

  // listen branch change
  window.addEventListener(
    "branchChanged",
    updateBranch
  );

  return () => {

    window.removeEventListener(
      "branchChanged",
      updateBranch
    );

  };

}, []);


  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);

  const [supplierList, setSupplierList] =
    useState([]);

  const [supplierSearch, setSupplierSearch] =
    useState("");

     const [suppliers, setSuppliers] = useState([]);
    useEffect(() => {
    getSuppliers();
  }, []);

  const getSuppliers = async () => {
    try {
      const res = await api.get("Product/getSuppliers");
      setSuppliers(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const [productSearch, setProductSearch] =
    useState("");

  const [showSupplierModal,
    setShowSupplierModal] =
    useState(false);

    const [showProductModal,
    setShowProductModal] =
    useState(false);

  const [supplier, setSupplier] = useState({
    supplier_id: "",
    supplier_name: "",
    phone: "",
    address: "",
  });

  const [productErrors, setProductErrors] =
  useState({});

const [productForm, setProductForm] =
  useState({
    product_name: "",
    description: "",
    price: "",
    qty: "",
    pic: "",
    mrp: "",
    size: "",
    brand: "",
    finish: "",
    pcs_per_box: "",
    sqft_per_box: "",
    sqft_per_pcs: "",
    branch: "",
  });

/* ====================================== */
/* HANDLE CHANGE */
/* ====================================== */

const handleProductChange = (e) => {

  setProductForm({
    ...productForm,
    [e.target.name]: e.target.value,
  });

  setProductErrors({
    ...productErrors,
    [e.target.name]: "",
  });

};

/* ====================================== */
/* VALIDATE */
/* ====================================== */

const validateProduct = () => {

  let errors = {};

  if (
    !productForm.product_name.trim()
  ) {
    errors.product_name =
      "Product name required";
  }

  if (!productForm.brand) {
    errors.brand =
      "Please select brand";
  }

  if (!productForm.price) {
    errors.price =
      "Price required";
  }

  if (!productForm.qty) {
    errors.qty =
      "Qty required";
  }

  if (!productForm.finish) {
    errors.finish =
      "Select finish";
  }

  if (!productForm.branch) {
    errors.branch =
      "Select branch";
  }

  if (!productForm.pcs_per_box) {
    errors.pcs_per_box =
      "Pcs per box required";
  }

  if (!productForm.sqft_per_box) {
    errors.sqft_per_box =
      "Sqft per box required";
  }

  if (!productForm.sqft_per_pcs) {
    errors.sqft_per_pcs =
      "Sqft per pcs required";
  }

  setProductErrors(errors);

  return (
    Object.keys(errors).length === 0
  );

};

/* ====================================== */
/* SAVE PRODUCT */
/* ====================================== */

const saveProduct = async () => {

  if (!validateProduct()) return;

  try {

    const formData =
      new FormData();

    Object.keys(productForm).forEach(
      (key) => {
        formData.append(
          key,
          productForm[key]
        );
      }
    );

    await api.post(
      "/Product/insertProduct",
      formData
    );

    toast.success(
      "Product Added"
    );

    setShowProductModal(false);

  } catch (err) {

    console.log(err);

    toast.error(
      "Failed to add product"
    );

  }

};

  /* ====================================== */
/* STATE */
/* ====================================== */


const updatePurchaseItem = (
  purchase_item_id,
  field,
  value
) => {

  setSelectedOrder((prev) => ({

    ...prev,

    items: prev.items.map((item) =>

      item.purchase_item_id ===
      purchase_item_id

        ? {
            ...item,
            [field]: value,

           total:
  Number(
    field === "qty"
      ? value
      : item.qty
  ) *
  Number(
    field === "cost_price"
      ? value
      : item.cost_price
  ),
          }

        : item

    ),

  }));

};


const savePurchaseItem = async (
  item
) => {

  try {

    await api.post(
      "/purchase/updatePurchaseItem",
      {
        purchase_item_id:
          item.purchase_item_id,

        qty: item.qty,

          cost_price: item.cost_price,

    sqft_per_box:
      item.sqft_per_box,
      }
    );

    alert("Updated");

  } catch (err) {

    console.log(err);

  }

};

const [showHistoryModal,
  setShowHistoryModal] =
  useState(false);

const [history, setHistory] =
  useState([]);

/* ====================================== */
/* OPEN HISTORY */
/* ====================================== */

const openHistory = async (
  product_id
) => {

  try {

    const res = await api.post(
      "/purchase/getPurchaseHistoryID",
      {
        product_id,
      }
    );

    setHistory(
      res.data.data || []
    );

    setShowHistoryModal(true);

  } catch (err) {

    console.log(err);

  }

};

  const [showModal, setShowModal] =
    useState(false);

  const [selectedOrder, setSelectedOrder] =
    useState(null);


    /* ====================================== */
/* SHARE PDF */
/* ====================================== */

const sharePDF = async () => {

  try {

    const blob = await pdf(

      <PurchasePDF
        order={selectedOrder.order}
        items={selectedOrder.items}
      />

    ).toBlob();

    const file = new File(
      [blob],
      `purchase_${selectedOrder.order.purchase_id}.pdf`,
      {
        type: "application/pdf",
      }
    );

    if (navigator.share) {

      await navigator.share({
        title: "Purchase Order",
        text: "Purchase Order PDF",
        files: [file],
      });

    } else {

      alert(
        "Share not supported in this device"
      );

    }

  } catch (err) {

    console.log(err);

  }

};

  /* ====================================== */
  /* FETCH */
  /* ====================================== */

  const fetchOrders = () => {

    api
      .get("/purchase/getPurchaseOrders")
      .then((res) => {
        setOrders(res.data.data || []);
      })
      .catch((err) => console.log(err));

  };

  useEffect(() => {

    fetchOrders();

    api
      .get("/Product/getProduct")
      .then((res) => {
        setProducts(res.data.data || []);
      })
      .catch((err) => console.log(err));

    api
      .get("/supplier/getSuppliers")
      .then((res) => {
        setSupplierList(
          res.data.data || []
        );
      })
      .catch((err) => console.log(err));

  }, []);

  /* ====================================== */
  /* ADD PRODUCT */
  /* ====================================== */

  const addToCart = (product) => {

    const exists = cart.find(
      (x) =>
        x.product_id === product.product_id
    );

    if (exists) return;

   setCart([
  ...cart,
  {
    product_id: product.product_id,
    product_name: product.product_name,

    qty: 1,

    cost_price:
      product.cost_price ||
      product.price ||
      0,

    sqft_per_box:
      product.sqft_per_box || 0,

    pcs_per_box:
      product.pcs_per_box || 0,
  },
]);

    setProductSearch("");

  };

  /* ====================================== */
  /* UPDATE CART */
  /* ====================================== */

  const updateCart = (
    product_id,
    field,
    value
  ) => {

    setCart((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? {
              ...item,
              [field]: value,
            }
          : item
      )
    );

  };

  /* ====================================== */
  /* REMOVE */
  /* ====================================== */

  const removeCart = (product_id) => {

    setCart((prev) =>
      prev.filter(
        (x) =>
          x.product_id !== product_id
      )
    );

  };

  /* ====================================== */
  /* TOTAL */
  /* ====================================== */

 const totalAmount = cart.reduce(
  (sum, item) =>
    sum +
    (
      Number(item.qty) *
      Number(item.sqft_per_box) *
      Number(item.cost_price)
    ),
  0
);

  /* ====================================== */
  /* CREATE PURCHASE */
  /* ====================================== */

  const createPurchase = async () => {

    try {

      if (!supplier.supplier_name) {
        alert("Select Supplier");
        return;
      }

      if (cart.length === 0) {
        alert("Add Products");
        return;
      }

  await api.post(
  "/purchase/createPurchase",
  {
    supplier_id: supplier.supplier_id,
    branch: selectedBranch,
    supplier_name: supplier.supplier_name,
    phone: supplier.phone,
    address: supplier.address,

    items: cart.map((item) => ({

      ...item,

      totalPrice:
        Number(item.qty) *
        Number(item.sqft_per_box) *
        Number(item.cost_price),

    })),

    total: totalAmount,

  }
);

      alert("Purchase Created");

      setCart([]);

    setSupplier({
  supplier_id: "",
  branch:"",
  supplier_name: "",
  phone: "",
  address: "",
});

      setSupplierSearch("");

      fetchOrders();

    } catch (err) {

      console.log(err);

    }

  };

  /* ====================================== */
  /* VIEW PURCHASE */
  /* ====================================== */

  const openOrder = async (
    purchase_id
  ) => {

    try {

      const res = await api.get(
        `/purchase/getPurchase/${purchase_id}`
      );

      setSelectedOrder(res.data);

      setShowModal(true);

    } catch (err) {

      console.log(err);

    }

  };

  /* ====================================== */
  /* ADD STOCK */
  /* ====================================== */

  const addStock = async (
    purchase_item_id
  ) => {

    try {

      const ok = window.confirm(
        "Add stock to inventory?"
      );

      if (!ok) return;

      await api.post(
        `/purchase/addPurchaseStock/${purchase_item_id}`
      );

      alert("Stock Added");

      const res = await api.get(
        `/purchase/getPurchase/${selectedOrder.order.purchase_id}`
      );

      setSelectedOrder(res.data);

      fetchOrders();

    } catch (err) {

      console.log(err);

    }

  };

  /* ====================================== */
  /* ADD SUPPLIER */
  /* ====================================== */

  const addSupplier = async () => {

    try {

      await api.post(
        "/supplier/createSupplier",
        supplier
      );

      alert("Supplier Added");

      const res = await api.get(
        "/supplier/getSuppliers"
      );

      setSupplierList(
        res.data.data || []
      );

      setShowSupplierModal(false);

    } catch (err) {

      console.log(err);

    }

  };

  return (

    <div className="p-4 space-y-6">

      {/* HEADER */}
      <div>

        <h1 className="text-3xl font-bold text-gray-800">
          Purchase Order
        </h1>

        <p className="text-gray-500 mt-1">
          Inventory Purchase Management
        </p>

      </div>

      {/* SUPPLIER */}
      <div className="bg-white rounded-3xl shadow-xl border p-5">

        <div className="
          flex
          flex-col
          md:flex-row
          gap-4
        ">

          {/* SEARCH */}
          <div className="relative flex-1">

            <input
              type="text"
              placeholder="Search Supplier..."
              value={supplierSearch}
              onChange={(e) =>
                setSupplierSearch(
                  e.target.value
                )
              }
              className="
                w-full
                border
                rounded-2xl
                p-3
              "
            />

            {supplierSearch && (

              <div
                className="
                  absolute
                  top-full
                  left-0
                  right-0
                  bg-white
                  border
                  rounded-2xl
                  shadow-xl
                  max-h-60
                  overflow-y-auto
                  z-50
                  mt-2
                "
              >

                {supplierList
                  .filter((s) =>
                    s.supplier_name
                      ?.toLowerCase()
                      .includes(
                        supplierSearch.toLowerCase()
                      )
                  )
                  .map((s) => (

                    <div
                      key={s.supplier_id}
                      onClick={() => {

                       setSupplier({
  supplier_id: s.supplier_id,
  supplier_name: s.supplier_name,
  phone: s.phone,
  address: s.address,
});

                        setSupplierSearch(
                          s.supplier_name
                        );

                      }}
                      className="
                        p-3
                        hover:bg-blue-50
                        cursor-pointer
                        border-b
                      "
                    >

                      <h3 className="font-bold">
                        {s.supplier_name}
                      </h3>

                      <p className="text-sm text-gray-500">
                        {s.phone}
                      </p>

                    </div>

                  ))}

              </div>

            )}

          </div>

          <button
            onClick={() =>
              setShowSupplierModal(true)
            }
            className="
              bg-blue-600
              text-white
              px-5
              py-3
              rounded-2xl
            "
          >
            + Add Supplier
          </button>

        </div>

        {/* SELECTED SUPPLIER */}
        {supplier.supplier_name && (

          <div className="
            mt-5
            border
            rounded-2xl
            p-4
            bg-blue-50
          ">

            <h2 className="font-bold text-lg">
              {supplier.supplier_name}
            </h2>

            <p className="text-gray-600 mt-1">
              {supplier.phone}
            </p>

            <p className="text-gray-500 text-sm">
              {supplier.address}
            </p>

          </div>

        )}

      </div>

      {/* PRODUCT + CART */}
      <div className="
        grid
        md:grid-cols-2
        gap-6
      ">

        {/* PRODUCT */}
       <div
  className="
    bg-white
    rounded-3xl
    shadow-xl
    border
    p-5
  "
>

  {/* HEADER */}
  <div className="flex items-center justify-between gap-3 mb-4">

    <h2
      className="
        text-xl
        font-bold
      "
    >
      Products
    </h2>

    {/* ADD PRODUCT BUTTON */}
    <button
      type="button"
      onClick={() =>
        setShowProductModal(true)
      }
      className="
        bg-green-600
        hover:bg-green-700
        text-white
        px-4
        py-2
        rounded-2xl
        text-sm
        font-semibold
        whitespace-nowrap
      "
    >
      + Add Product
    </button>

  </div>

  {/* SEARCH */}
  <div className="relative">

    <input
      type="text"
      placeholder="Search Product..."
      value={productSearch}
      onChange={(e) =>
        setProductSearch(
          e.target.value
        )
      }
      className="
        w-full
        border
        rounded-2xl
        p-3
      "
    />

    {productSearch && (

      <div
        className="
          absolute
          top-full
          left-0
          right-0
          bg-white
          border
          rounded-2xl
          shadow-xl
          max-h-96
          overflow-y-auto
          z-50
          mt-2
        "
      >

        {products
          .filter((p) =>
            p.product_name
              ?.toLowerCase()
              .includes(
                productSearch.toLowerCase()
              )
          )
          .map((item) => (

            <div
              key={item.product_id}
              onClick={() =>
                addToCart(item)
              }
              className="
                flex
                items-center
                gap-3
                p-3
                hover:bg-blue-50
                cursor-pointer
                border-b
              "
            >

              <img
                src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.image}`}
                alt=""
                className="
                  w-14
                  h-14
                  rounded-xl
                  object-cover
                  border
                "
              />

              <div>

                <h3 className="font-bold">
                  {item.product_name}
                </h3>

                <p
                  className="
                    text-sm
                    text-gray-500
                  "
                >
                  Stock : {item.qty}
                </p>

                <p
                  className="
                    text-sm
                    font-bold
                    text-blue-600
                  "
                >
                  ₹{item.price}
                </p>

              </div>

            </div>

          ))}

      </div>

    )}

  </div>

</div>

        {/* CART */}
        <div className="
          bg-white
          rounded-3xl
          shadow-xl
          border
          p-5
        ">

          <h2 className="
            text-xl
            font-bold
            mb-4
          ">
            Purchase Cart
          </h2>

          <div className="
            space-y-4
            max-h-[500px]
            overflow-y-auto
          ">

            {cart.length === 0 && (

              <div className="
                text-center
                py-20
                text-gray-400
              ">
                No products added
              </div>

            )}

          {cart.map((item) => {

  const totalPrice =
    Number(item.qty) *
    Number(item.sqft_per_box) *
    Number(item.cost_price);

  return (

    <div
      key={item.product_id}
      className="
        border
        rounded-2xl
        p-4
      "
    >

      <div className="
        flex
        justify-between
        items-center
      ">

        <div>

          <h3 className="
            font-bold
            text-lg
          ">
            {item.product_name}
          </h3>

          <p className="
            text-sm
            text-gray-500
          ">
            Product ID :
            #{item.product_id}
          </p>

        </div>

        <button
          onClick={() =>
            removeCart(
              item.product_id
            )
          }
          className="
            text-red-500
            text-xl
          "
        >
          ✖
        </button>

      </div>

      <div className="
        grid
        grid-cols-2
        gap-3
        mt-4
      ">

        {/* QTY */}

        <div>

          <label className="
            text-sm
            text-gray-500
          ">
            Qty
          </label>

          <input
            type="number"
            value={item.qty}
            onChange={(e) =>
              updateCart(
                item.product_id,
                "qty",
                e.target.value
              )
            }
            className="
              w-full
              border
              rounded-xl
              p-2
              mt-1
            "
          />

        </div>

        {/* COST PRICE */}

        <div>

          <label className="
            text-sm
            text-gray-500
          ">
            Cost Price
          </label>

          <input
            type="number"
            value={item.cost_price}
            onChange={(e) =>
              updateCart(
                item.product_id,
                "cost_price",
                e.target.value
              )
            }
            className="
              w-full
              border
              rounded-xl
              p-2
              mt-1
            "
          />

        </div>

      </div>

      {/* TOTAL */}

      <div className="
        mt-4
        text-right
      ">

        <p className="
          text-sm
          text-gray-500
        ">
          {item.qty} Box ×
          {item.sqft_per_box} Sqft ×
          ₹{item.cost_price}
        </p>

        <h2 className="
          text-2xl
          font-bold
          text-green-600
        ">
          ₹{totalPrice}
        </h2>

      </div>

    </div>

  );

})}

          </div>

          {/* TOTAL */}
          <div className="
            border-t
            mt-5
            pt-5
          ">

            <div className="
              flex
              justify-between
              items-center
            ">

              <div>

                <p className="text-gray-500">
                  Total Amount
                </p>

                <h2 className="
                  text-3xl
                  font-bold
                  text-blue-600
                ">
                  ₹{totalAmount}
                </h2>

              </div>

              <button
                onClick={createPurchase}
                className="
                  bg-green-600
                  hover:bg-green-700
                  text-white
                  px-6
                  py-3
                  rounded-2xl
                "
              >
                Create Purchase
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* PURCHASE LIST */}
    <div className="
  bg-white
  rounded-3xl
  shadow-xl
  border
  p-5
">

  <h2 className="
    text-2xl
    font-bold
    mb-5
  ">
    Purchase Orders
  </h2>

  <div className="
    grid
    md:grid-cols-5
    gap-4
  ">

    {orders.map((item) => (

      <div
        key={item.purchase_id}
        className="
          border
          rounded-3xl
          p-5
          shadow-sm
          hover:shadow-xl
          transition-all
          bg-gradient-to-br
          from-white
          to-gray-50
        "
      >

        {/* TOP */}

        <div className="
          flex
          justify-between
          items-start
        ">

          <div>

            <h2 className="
              text-2xl
              font-bold
              text-gray-800
            ">
              #{item.purchase_id}
            </h2>

            <p className="
              text-gray-600
              mt-1
              font-medium
            ">
              {item.supplier_name}
            </p>

          </div>

          <span
            className={`
              px-3 py-1 rounded-full text-xs font-bold h-fit
              ${
                item.status === "Received"
                  ? "bg-green-100 text-green-700"
                  : "bg-yellow-100 text-yellow-700"
              }
            `}
          >
            {item.status}
          </span>

        </div>

        {/* BRANCH */}

        <div className="mt-4">

          <p className="
            text-xs
            text-gray-500
            mb-1
          ">
            Branch
          </p>

          <h3 className="
            font-bold
            text-blue-700
          ">
            {Number(item.branch) === 2
              ? "A.K. CERAMIC WORLD"
              : "A.K. TILES PARK"}
          </h3>

        </div>

        {/* DATE */}

        <div className="mt-4">

          <p className="
            text-xs
            text-gray-500
            mb-1
          ">
            Purchase Date
          </p>

          <h3 className="
            font-semibold
            text-gray-700
          ">
            {moment(item.created_at).format("DD/MM/YYYY")}
          </h3>

        </div>

        {/* AMOUNT */}

        <div className="mt-5">

          <p className="
            text-xs
            text-gray-500
          ">
            Total Amount
          </p>

          <h2 className="
            text-3xl
            font-bold
            text-blue-600
            mt-1
          ">
            ₹{item.total_amount}
          </h2>

        </div>

        {/* BUTTON */}

        <button
          onClick={() =>
            openOrder(item.purchase_id)
          }
          className="
            mt-5
            w-full
            bg-blue-600
            hover:bg-blue-700
            text-white
            py-3
            rounded-2xl
            font-semibold
            transition-all
          "
        >
          View Purchase Items
        </button>

      </div>

    ))}

  </div>

</div>

  {/* VIEW MODAL */}

<AnimatePresence>

  {showModal && selectedOrder && (

    <motion.div
      className="
        fixed
        inset-0
        bg-black/70
        backdrop-blur-sm
        flex
        items-center
        justify-center
        z-[9999]
        p-3
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() =>
        setShowModal(false)
      }
    >

      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        onClick={(e) =>
          e.stopPropagation()
        }
        className="
          bg-white
          w-full
          max-w-5xl
          rounded-3xl
          overflow-hidden
          shadow-2xl
        "
      >

        {/* HEADER */}

        <div
          className="
            bg-gray-900
            text-white
            p-5
            flex
            flex-col
            md:flex-row
            md:justify-between
            md:items-center
            gap-4
          "
        >

          <div>

            <h2
              className="
                text-3xl
                font-bold
              "
            >
              Purchase #
              {
                selectedOrder.order
                  .purchase_id
              }
            </h2>

            <p
              className="
                text-sm
                opacity-80
                mt-1
              "
            >
              {
                selectedOrder.order
                  .supplier_name
              }
            </p>

          </div>

          <div
            className="
              flex
              items-center
              gap-3
              flex-wrap
            "
          >

            {/* PDF */}

            <PDFDownloadLink
              document={
                <PurchasePDF
                  order={
                    selectedOrder.order
                  }
                  items={
                    selectedOrder.items
                  }
                />
              }
              fileName={`purchase_${selectedOrder.order.purchase_id}.pdf`}
            >

              {({ loading }) => (

                <button
                  className="
                    bg-white
                    text-black
                    px-5
                    py-2.5
                    rounded-xl
                    font-bold
                  "
                >
                  {loading
                    ? "Loading..."
                    : "PDF"}
                </button>

              )}

            </PDFDownloadLink>

            {/* SHARE */}

            <button
              onClick={sharePDF}
              className="
                bg-green-500
                hover:bg-green-600
                text-white
                px-5
                py-2.5
                rounded-xl
                font-bold
              "
            >
              Share
            </button>

            {/* CLOSE */}

            <button
              onClick={() =>
                setShowModal(false)
              }
              className="
                text-3xl
                leading-none
              "
            >
              ✖
            </button>

          </div>

        </div>

        {/* BODY */}

        <div
          className="
            p-5
            space-y-5
            max-h-[75vh]
            overflow-y-auto
            bg-gray-100
          "
        >

          {selectedOrder.items.map(
            (item) => (

              <div
                key={
                  item.purchase_item_id
                }
                className="
                  bg-white
                  border
                  rounded-3xl
                  p-5
                  shadow-sm
                "
              >

                <div
                  className="
                    flex
                    flex-col
                    md:flex-row
                    md:justify-between
                    gap-6
                  "
                >

                  {/* LEFT */}

                  <div className="flex-1">

                    <h3
                      className="
                        text-2xl
                        font-bold
                        text-gray-800
                      "
                    >
                      {
                        item.product_name
                      }
                    </h3>

                    {/* QTY + SAVE */}
<div
  className="
    mt-5
    grid
    grid-cols-1
    md:grid-cols-[140px_180px_120px]
    gap-4
    items-end
  "
>

  {/* QTY */}

  <div>

    <label
      className="
        block
        text-sm
        text-gray-500
        font-medium
        mb-1
      "
    >
      Qty
    </label>

    <input
      type="number"
      value={item.qty}
      disabled={item.received === 1}
      onChange={(e) =>
        updatePurchaseItem(
          item.purchase_item_id,
          "qty",
          e.target.value
        )
      }
      className={`
        w-full
        h-[52px]
        border
        rounded-xl
        px-4
        outline-none
        focus:ring-2
        focus:ring-blue-500

        ${
          item.received === 1
            ? "bg-gray-100 cursor-not-allowed opacity-60"
            : "bg-white"
        }
      `}
    />

  </div>

  {/* COST PRICE */}

  <div>

    <label
      className="
        block
        text-sm
        text-gray-500
        font-medium
        mb-1
      "
    >
      Cost Price
    </label>

    <input
      type="number"
      value={item.cost_price}
      disabled={item.received === 1}
      onChange={(e) =>
        updatePurchaseItem(
          item.purchase_item_id,
          "cost_price",
          e.target.value
        )
      }
      className={`
        w-full
        h-[52px]
        border
        rounded-xl
        px-4
        outline-none
        focus:ring-2
        focus:ring-blue-500

        ${
          item.received === 1
            ? "bg-gray-100 cursor-not-allowed opacity-60"
            : "bg-white"
        }
      `}
    />

  </div>

  {/* SAVE BUTTON */}

  <button
    onClick={() =>
      savePurchaseItem(item)
    }
    disabled={item.received === 1}
    className={`
      h-[52px]
      px-5
      rounded-xl
      text-sm
      font-semibold
      transition

      ${
        item.received === 1
          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700 text-white"
      }
    `}
  >
    Save
  </button>

</div>

                    {/* PRICE */}

    

                    {/* TOTAL */}

                    <h2
                      className="
                        text-4xl
                        font-bold
                        text-green-600
                        mt-4
                      "
                    >
         ₹{
    Number(item.qty) *
    Number(item.sqft_per_box) *
    Number(item.cost_price)
  }
                    </h2>

                  </div>

                  {/* RIGHT */}

                  <div
                    className="
                      flex
                      flex-col
                      gap-3
                      w-full
                      md:w-[220px]
                    "
                  >

                    {/* HISTORY */}

                    <button
                      onClick={() =>
                        openHistory(
                          item.product_id
                        )
                      }
                      className="
                        bg-blue-600
                        hover:bg-blue-700
                        text-white
                        px-4
                        py-3
                        rounded-xl
                        text-sm
                        font-semibold
                        transition
                        w-full
                      "
                    >
                      View History
                    </button>

                    {/* STATUS */}

                    {item.received ===
                    1 ? (

                      <span
                        className="
                          bg-green-100
                          text-green-700
                          px-4
                          py-3
                          rounded-xl
                          text-sm
                          font-bold
                          text-center
                          w-full
                        "
                      >
                        Stock Added
                      </span>

                    ) : (

                      <>

                        <span
                          className="
                            bg-yellow-100
                            text-yellow-700
                            px-4
                            py-3
                            rounded-xl
                            text-sm
                            font-bold
                            text-center
                            w-full
                          "
                        >
                          Pending
                        </span>

                        <button
                          onClick={() =>
                            addStock(
                              item.purchase_item_id
                            )
                          }
                          className="
                            bg-green-600
                            hover:bg-green-700
                            text-white
                            px-4
                            py-3
                            rounded-xl
                            text-sm
                            font-semibold
                            transition
                            w-full
                          "
                        >
                          + Add Qty Stock
                        </button>

                      </>

                    )}

                  </div>

                </div>

              </div>

            )
          )}

        </div>

      </motion.div>

    </motion.div>

  )}

</AnimatePresence>

{/* PRODUCT MODAL */}

 <AnimatePresence>

  {showProductModal && (

    <motion.div
      className="
        fixed
        inset-0
        bg-black/70
        backdrop-blur-sm
        flex
        items-center
        justify-center
        z-[9999]
        p-3
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() =>
        setShowProductModal(false)
      }
    >

      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        onClick={(e) =>
          e.stopPropagation()
        }
        className="
          bg-white
          w-full
          max-w-5xl
          rounded-3xl
          p-6
          max-h-[95vh]
          overflow-y-auto
        "
      >

        <div className="
          flex
          justify-between
          items-center
          mb-6
        ">

          <h2 className="
            text-3xl
            font-bold
          ">
            Add Product
          </h2>

          <button
            onClick={() =>
              setShowProductModal(false)
            }
            className="text-3xl"
          >
            ✖
          </button>

        </div>

        <div className="
          grid
          md:grid-cols-2
          gap-4
        ">

          {/* PRODUCT NAME */}

          <div>

            <label>
              Product Name
            </label>

            <input
              type="text"
              name="product_name"
              value={
                productForm.product_name
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.product_name && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.product_name
                }
              </p>

            )}

          </div>

          {/* BRAND */}

          <div>

            <label>
              Brand
            </label>

            <select
              name="brand"
              value={
                productForm.brand
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

             <option value="">Select Brand</option>
    <option value="Varmora">Varmora</option>
    <option value="Bonzer7">Bonzer 7</option>
     <option value="Anmol ceramic">Anmol ceramic</option>
      <option value="Koya">Koya</option>
       <option value="Kethos">Kethos</option>
        <option value="Admin">Admin</option>
        <option value="Nucera">Nucera</option>
        <option value="Orientbell">Orientbell</option>
         <option value="Delfina">Delfina</option>
          <option value="Swizzer Ceramic">Swizzer Ceramic</option>
           <option value="Bathsense">Bathsense</option>
             <option value="Essess">Essess</option>
           <option value="Neycer">Neycer</option>
            <option value="Parryware">Parryware</option>
    <option value="Hindware">Hindware</option>
    <option value="Somany">Somany</option>
    <option value="Sunheart">Sunheart</option>
    <option value="Bluezone">Bluezone</option>
    <option value="Active">Active</option>
    <option value="BX">BX</option>
    <option value="Simpolo">Simpolo</option>
    <option value="Captiva">Captiva</option>
    <option value="RJM">RJM</option>
    <option value="LIJO">LIJO</option>

            </select>

            {productErrors.brand && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.brand
                }
              </p>

            )}

          </div>

          {/* PRICE */}

          <div>

            <label>
              Price
            </label>

            <input
              type="number"
              name="price"
              value={
                productForm.price
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.price && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.price
                }
              </p>

            )}

          </div>
           <div>
              <label className="block mb-1 font-medium">MRP</label>
              <input
                type="number"
                name="mrp"
                value={productForm.mrp || ""}
                onChange={handleProductChange}
                className="input w-full"
              />
            </div>

        
<div>

  <label className="block mb-1 font-medium">
    Quantity
  </label>

  <div className="flex gap-2">

    {/* BOX */}

    <input
      type="number"
      name="qty"
      value={productForm.qty || ""}
      onChange={handleProductChange}
      placeholder="Box"
      className="
        w-1/2
        border
        p-3
        rounded-xl
        mt-1
      "
    />

    {/* PCS */}

    <input
      type="number"
      name="pic"
      value={productForm.pic || ""}
      onChange={handleProductChange}
      placeholder="Pcs"
      className="
        w-1/2
        border
        p-3
        rounded-xl
        mt-1
      "
    />

  </div>

  {productErrors.qty && (

    <p className="
      text-red-500
      text-sm
      mt-1
    ">
      {productErrors.qty}
    </p>

  )}

</div>

          {/* SIZE */}

          <div>

            <label>
              Tile Size
            </label>

            <select
              name="size"
              value={
                productForm.size
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

             <option value="">Select Size</option>
    <option value="1200 x 600">1200 x 600</option>
    <option value="600 x 600">600 x 600</option>
    <option value="300 x 450">300 x 450</option>
    <option value="15 x 10">15 x 10</option>
    <option value="1200 x 200">1200 x 200</option>
    <option value="300 x 600">300 x 600</option>
    <option value="2400 x 1200">2400 x 1200</option>
    <option value="300 x 300">300 x 300</option>
    <option value="400 x 400">400 x 400</option>
    <option value="200 x 200">200 x 200</option>
    <option value="800 x 1600">800 x 1600</option>
    <option value="1200 x 1800">1200 x 1800</option>
    <option value="800 x 2400">800 x 2400</option>

            </select>

          </div>

          
           <div>
  <label className="block mb-1 font-medium text-gray-700">
    Supplier
  </label>

  <select
    name="supplier_id"
    value={productForm.supplier_id || ""}
    onChange={handleProductChange}
    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
  >
    <option value="">Select Supplier</option>

    {suppliers.map((item) => (
      <option
        key={item.supplier_id}
        value={item.supplier_id}
      >
        {item.supplier_name}
      </option>
    ))}
  </select>
</div>

          {/* FINISH */}

          <div>

            <label>
              Finish
            </label>

            <select
              name="finish"
              value={
                productForm.finish
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

              <option value="">Select Finish</option>
    <option value="Glossy">Glossy</option>
    <option value="Matt">Matt</option>
    <option value="High Gloss">High Gloss</option>
    <option value="Polished">Polished</option>
    <option value="Carving">Carving</option>
    <option value="3D Elevation">3D Elevation</option>
    <option value="Rustic">Rustic</option>
    <option value="Wood">Wood</option>
    <option value="Stone">Stone</option>
    <option value="Anti Skid">Anti Skid</option>

            </select>

            {productErrors.finish && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.finish
                }
              </p>

            )}

          </div>

          {/* BRANCH */}

          <div>

            <label>
              Branch
            </label>

            <select
              name="branch"
              value={
                productForm.branch
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >
<option value="">Select Finish</option>
    <option value="A K Ceramic World">A K Ceramic World</option>
    <option value="A K Tiles Park">A K Tiles Park</option>
    <option value="A K Tiles Park Green">A K Tiles Park Green</option>
    <option value="A K Tiles Park Main road">A K Tiles Park Main road</option>
    <option value="A K Tiles Park show room">A K Tiles Park show room</option>

            </select>

            {productErrors.branch && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.branch
                }
              </p>

            )}

          </div>

          {/* PCS */}

          <div>

            <label>
              Pcs per box
            </label>

            <input
              type="number"
              name="pcs_per_box"
              value={
                productForm.pcs_per_box
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.pcs_per_box && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.pcs_per_box
                }
              </p>

            )}

          </div>

          {/* SQFT BOX */}

          <div>

            <label>
              Sqft per box
            </label>

            <input
              type="number"
              name="sqft_per_box"
              value={
                productForm.sqft_per_box
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.sqft_per_box && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.sqft_per_box
                }
              </p>

            )}

          </div>

          {/* SQFT PCS */}

          <div>

            <label>
              Sqft per pcs
            </label>

            <input
              type="number"
              name="sqft_per_pcs"
              value={
                productForm.sqft_per_pcs
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.sqft_per_pcs && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.sqft_per_pcs
                }
              </p>

            )}

          </div>

        </div>

        {/* DESCRIPTION */}

        <div className="mt-5">

          <label>
            Description
          </label>

          <textarea
            name="description"
            value={
              productForm.description
            }
            onChange={
              handleProductChange
            }
            className="
              w-full
              border
              p-3
              rounded-xl
              mt-1
            "
          />

        </div>

        {/* BUTTON */}

        <button
  type="button"
  onClick={() => {
    saveProduct();
  }}
  
  className="
    w-full
    mt-6
    bg-green-600
    hover:bg-green-700
    disabled:bg-gray-400
    text-white
    py-4
    rounded-2xl
    font-bold
  "
>
 Save
</button>

      </motion.div>

    </motion.div>

  )}

</AnimatePresence>

      {/* SUPPLIER MODAL */}
      <AnimatePresence>

        {showSupplierModal && (

          <motion.div
            className="
              fixed inset-0
              bg-black/70
              backdrop-blur-sm
              flex items-center justify-center
              z-[9999]
              p-3
            "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() =>
              setShowSupplierModal(false)
            }
          >

            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) =>
                e.stopPropagation()
              }
              className="
                bg-white
                w-full
                max-w-md
                rounded-3xl
                p-6
              "
            >

              <h2 className="
                text-2xl
                font-bold
                mb-5
              ">
                Add Supplier
              </h2>

              <div className="
                space-y-4
              ">

                <input
                  placeholder="Supplier Name"
                  value={
                    supplier.supplier_name
                  }
                  onChange={(e) =>
                    setSupplier({
                      ...supplier,
                      supplier_name:
                        e.target.value,
                    })
                  }
                  className="
                    w-full
                    border
                    rounded-2xl
                    p-3
                  "
                />

                <input
                  placeholder="Phone"
                  value={supplier.phone}
                  onChange={(e) =>
                    setSupplier({
                      ...supplier,
                      phone:
                        e.target.value,
                    })
                  }
                  className="
                    w-full
                    border
                    rounded-2xl
                    p-3
                  "
                />

                <textarea
                  placeholder="Address"
                  value={supplier.address}
                  onChange={(e) =>
                    setSupplier({
                      ...supplier,
                      address:
                        e.target.value,
                    })
                  }
                  className="
                    w-full
                    border
                    rounded-2xl
                    p-3
                  "
                />

                <button
                  onClick={addSupplier}
                  className="
                    w-full
                    bg-blue-600
                    text-white
                    py-3
                    rounded-2xl
                    font-bold
                  "
                >
                  Save Supplier
                </button>

              </div>

            </motion.div>

          </motion.div>

        )}

      </AnimatePresence>
      {/* HISTORY MODAL */}

<AnimatePresence>

  {showHistoryModal && (

    <motion.div
      className="
        fixed
        inset-0
        bg-black/70
        backdrop-blur-sm
        flex
        items-center
        justify-center
        z-[9999]
        p-3
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() =>
        setShowHistoryModal(false)
      }
    >

      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        onClick={(e) =>
          e.stopPropagation()
        }
        className="
          bg-white
          w-full
          max-w-3xl
          rounded-3xl
          overflow-hidden
        "
      >

        {/* HEADER */}

        <div className="
          bg-blue-600
          text-white
          p-5
          flex
          justify-between
          items-center
        ">

          <h2 className="
            text-2xl
            font-bold
          ">
            Purchase History
          </h2>

          <button
            onClick={() =>
              setShowHistoryModal(false)
            }
            className="text-2xl"
          >
            ✖
          </button>

        </div>

        {/* BODY */}

        <div className="
          p-5
          bg-gray-50
          max-h-[75vh]
          overflow-y-auto
        ">

          <div className="space-y-4">

            {history.length === 0 && (

              <div className="
                text-center
                py-10
                text-gray-400
              ">
                No History Found
              </div>

            )}

            {history.map((item) => (

              <div
                key={item.history_id}
                className="
                  border
                  rounded-2xl
                  p-4
                  bg-white
                  flex
                  justify-between
                  items-center
                "
              >

                <div>

                  <h3 className="
                    font-bold
                    text-lg
                  ">
                    {item.product_name}
                  </h3>
                  <p className="
  text-sm
  text-gray-500
">
  Purchase ID :
  {" "}
  #{item.purchase_id}
</p>
                  <p className="
                    text-sm
                    text-gray-500
                    mt-1
                  ">
                    Supplier :
                    {" "}
                    {item.supplier_name}
                  </p>

                  <p className="
                    text-sm
                    text-gray-500
                  ">
                    Qty :
                    {" "}
                    {item.qty}
                  </p>

                  <p className="
                    text-sm
                    font-bold
                    text-green-600
                  ">
                    ₹ {item.total}
                  </p>

                </div>

                <div className="
                  text-right
                ">

                  <span
                    className={`
                      px-3
                      py-1
                      rounded-full
                      text-xs
                      font-bold
                      ${
                        item.action_type ===
                        "STOCK_ADDED"
                          ? "bg-green-100 text-green-600"
                          : "bg-blue-100 text-blue-600"
                      }
                    `}
                  >
                    {item.action_type}
                  </span>

                  <p className="
                    text-xs
                    text-gray-400
                    mt-2
                  ">
                    {item.created_at}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </motion.div>

    </motion.div>

  )}

</AnimatePresence>

    </div>

  );

}